import React, { useEffect } from "react";
import styles from './index.css';
import datePickerStyles from "react-day-picker/style.css";

import { createRoot } from "react-dom/client";
import OlympicSearch from "./widgets/olympicSearch.jsx";
import root from 'react-shadow';

const mountNodes = document.querySelectorAll("[data-search-form]");
mountNodes.forEach(mountNode => {
  var usePortal = mountNode.dataset.searchUseportal == "true";
  let overviewNode = null;
  if (usePortal) {
    overviewNode = document.querySelector("[data-search-overview]");
  }

  createRoot(mountNode).render(<root.div >
    <OlympicSearch
      overviewNode={overviewNode}
      baseUrl={mountNode.dataset.baseUrl}
      bookingEngineBaseUrl={mountNode.dataset.bookingEngineBaseUrl}
      specificSearch={JSON.parse(mountNode.dataset.specificSearch ?? null)}
      specificAccom={JSON.parse(mountNode.dataset.specificAccom ?? null)}
      showForm = {true}
    />
    <style type="text/css">{styles}</style>
    <style type="text/css">{datePickerStyles}</style>
  </root.div>
  );
});

// Consumers (e.g. the booking engine header) may call this again for the same
// node when their state changes. createRoot() must only run once per node -
// a second call on the same container detaches the first root and can leave
// the form blank - so reuse the existing root and just re-render.
const searchRoots = new WeakMap();
window.OlympicSearch = ({ mountNode, overviewNode, baseUrl, bookingEngineBaseUrl, specificSearch }) => {
  let reactRoot = searchRoots.get(mountNode);
  if (!reactRoot) {
    reactRoot = createRoot(mountNode);
    searchRoots.set(mountNode, reactRoot);
  }
  reactRoot.render(<root.div >
    {/* Key on the search so a repeat call with a different search re-seeds
        the widget state (it only reads specificSearch on mount). */}
    <OlympicSearch
      key={JSON.stringify(specificSearch ?? null)}
      overviewNode={overviewNode}
      baseUrl={baseUrl}
      bookingEngineBaseUrl={bookingEngineBaseUrl}
      specificSearch={specificSearch}
    />
    <style type="text/css">{styles}</style>
    <style type="text/css">{datePickerStyles}</style>
  </root.div>
  );
}